export default "__VITE_ASSET__B1R8l8rm__"